
import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import { AmplifyEventBus } from "aws-amplify-vue";
import { extend } from "vee-validate";
import auth from "@/services/auth";
import RouteParams from "@/entities/RouteParams";
import UiButton from "@/components/button/ui-button.vue";
import AuthFormLink from "@/components/auth/AuthFormLink.vue";
import AuthCard from "@/components/auth/AuthCard.vue";
import FormGroup from "@/components/form/FormGroupNew.vue";
import RouteNames from "@/entities/RouteNames";
import { NOTIFICATION } from "@/entities/Events";
import Message, { MessageDuration } from "@/data/notificationsMessages";
import JobBlissLogo from "@/components/icons/jobBlissLogo.vue";
import Roles from "@/entities/Roles";
import SectionTitle from "@/views/auth/common/SectionTitle.vue";
import AuthTitle from "@/components/auth/AuthTitle.vue";
import AuthSubTitle from "@/components/auth/AuthSubTitle.vue";
import CustomScroll from "@/components/scroll/CustomScroll.vue";
import SignUpRoles from "@/views/auth/SignUpRoles.vue";

interface ICompany {
  businessName: string;
  numberOfEmployee: number;
  city: string;
}

interface Observer extends Vue {
  reset: Function;
}

@Component({
  components: {
    SignUpRoles,
    JobBlissLogo,
    CustomScroll,
    AuthSubTitle,
    AuthTitle,
    SectionTitle,
    UiButton,
    AuthFormLink,
    FormGroup,
    AuthCard,
  },
  // apollo: {
  //   email_regex: {
  //     query: GET_REGEX,
  //   },
  // },
})
export default class SignUp extends Vue {
  temporary_regex?: string[] = [
    "outlook.com",
    "aol.com",
    "live.com",
    "hotmail.com",
    "yahoo.com",
    "yahoo.co.in",
    "gmail.com",
  ];

  loading: boolean = false;
  comapnyIntital: boolean = true;
  consentComapny: boolean = false;
  consentTalent: boolean = false;
  companySignUp: boolean = false;
  talentInitial: boolean = true;
  consentChecked: boolean = false;
  emailValidationPending: boolean = false;
  role: string = this.companySignUp ? Roles.ADMIN : Roles.CONTRACTOR;
  emailErrorMessage: string = "";
  prepopulated: boolean = false;
  messageOutput: string = "";
  roles = Roles;
  successMessage: string = "";
  errorMessage: string = "";

  email: string = "";
  givenName: string = "";
  familyName: string = "";
  euniceValidator: boolean = true;
  regexError: string = "";
  password: string = "";
  confirmPassword: string = "";
  company: ICompany = {
    businessName: "",
    numberOfEmployee: 0,
    city: "",
  };
  mounted() {
    if (this.$route.path.includes("talent")) {
      this.companySignUp = false;
    } else {
      this.companySignUp = true;
    }
  }
  beforeMount(): void {
    extend("is-email-registered", {
      validate: this.validateEmail,
      message: () => this.emailErrorMessage,
    });
  }

  @Watch("companySignUp")
  refreshErrors(): void {
    this.resetFields();
  }

  resetFields(): void {
    this.role = this.companySignUp ? Roles.ADMIN : Roles.CONTRACTOR;
    this.emailErrorMessage = "";
    this.prepopulated = false;
    this.messageOutput = "";
    this.email = "";
    this.givenName = "";
    this.familyName = "";
    this.euniceValidator = true;
    this.regexError = "";
    this.password = "";
    this.confirmPassword = "";
    this.company.businessName = "";
    this.company.numberOfEmployee = 0;
    this.company.city = "";
  }

  handleCompanyIntital(): void {
    this.comapnyIntital = false;
    this.consentComapny = true;
  }
  handleSecondStepComapny(): void {
    this.consentComapny = false;
  }

  handleComapnyClick() {
    this.companySignUp = false;
    this.talentInitial = true;
  }
  handleTalentInitial(): void {
    this.talentInitial = false;
    this.consentTalent = true;
  }
  handleSecondStepTalent() {
    this.consentTalent = false;
  }
  handleTalnetClick() {
    this.companySignUp = true;
    this.comapnyIntital = true;
  }

  async checkEmailRegex(regex: string[]) {
    let businessEmail = this.email.split("@")[1];
    if (regex.includes(businessEmail)) {
      this.regexError = `Free email providers "${businessEmail}" are not allowed for company registration!`;
      this.euniceValidator = true;
    } else {
      this.euniceValidator = false;
      this.regexError = "";
    }
  }
  async validateEmail(v: string) {
    this.emailValidationPending = true;
    try {
      const uri = `${process.env.VUE_APP_LAMBDA}/validate-email`;
      const { data }: any = await this.axios.post(uri, {
        data: { email: v.toLowerCase() },
      });
      this.emailErrorMessage = data.message;
      let regexArray = this.temporary_regex ? this.temporary_regex : [];
      if (this.companySignUp) {
        this.checkEmailRegex(regexArray);
      } else {
        this.euniceValidator = false;
      }
      return data.valid;
    } catch (error) {
      this.emailErrorMessage = error.message || error;
      return false;
    } finally {
      this.emailValidationPending = false;
    }
  }

  @Watch("role")
  watchRole(_: string, prev: string): void {
    if (!prev) {
      return;
    }

    (this.$refs.observer as Observer).reset();
    this.reset();
    this.prepopulated = false;
  }

  get title(): string {
    if (this.role === Roles.CONTRACTOR) {
      return "Sign up as a Contractor";
    }

    if (this.role === Roles.ADMIN) {
      return "Sign up as a Company";
    }

    return "Create an account";
  }

  get termsAndCondsURL(): string {
    return "https://www.proveracare.com/terms-and-conditions";
    //   return `${process.env.VUE_APP_LANDING_URL}/terms-and-conditions`;
  }

  get privacyPolicyURL(): string {
    return "https://www.proveracare.com/privacy";
    // return `${process.env.VUE_APP_LANDING_URL}/privacy-policy`;
  }

  contractorPageRoute(): RouteParams<{}> {
    return {
      name: RouteNames.SIGNIN,
    };
  }

  async submit(): Promise<void> {
    this.loading = true;

    try {
      await this._signUp();
      await AmplifyEventBus.$emit("authState", "signIn");
      this.errorMessage = ""; // Reset the error message if needed
      this.successMessage = "Check your inbox for the verification email.";
      window.location.href = "http://proveracare.com/";
    } catch (e) {
      this.errorMessage = e.message; // Set the error message
      this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
    } finally {
      this.loading = false;
    }
  }

  async _signUp() {
    const commonMetadata = {
      role: this.companySignUp ? Roles.ADMIN : Roles.CONTRACTOR,
      source: "signup",
      consentGiven: this.consentChecked ? "true" : "false",
      consentAt: new Date().toISOString(),
    };
    if (!this.companySignUp) {
      return await auth.signUp({
        username: this.email.toLowerCase(),
        password: this.password,
        attributes: {
          family_name: this.familyName,
          given_name: this.givenName,
        },
        clientMetadata: commonMetadata,
      });
    }

    return await auth.signUp({
      username: this.email.toLowerCase(),
      password: this.password,
      attributes: {
        family_name: this.familyName,
        given_name: this.givenName,
      },
      clientMetadata: {
        ...commonMetadata,
        city: "City",
        business_name: this.company.businessName,
        number_of_employee: this.company.numberOfEmployee.toString(),
      },
    });
  }

  reset(): void {
    this.email = "";
    this.givenName = "";
    this.familyName = "";
    this.password = "";
    this.confirmPassword = "";
    this.company = {
      businessName: "",
      numberOfEmployee: 0,
      city: "",
    };
  }
}
